import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { Tooltip } from 'ui/tooltip';
import { Avatar, AvatarProps, AVATAR_SIZE_TYPES, CountAvatar } from './Avatar';
import { AVATAR_SIZES } from './constants';

const StackedRow = styled.div<{ backgroundColor: string; size: AVATAR_SIZE_TYPES }>`
  display: flex;
  align-items: center;

  > * {
    position: relative;
    box-shadow: 0 0 0
      ${({ size }) => (size === AVATAR_SIZES.XLARGE ? spacing.quarter : spacing.eighth)}
      ${({ backgroundColor }) => backgroundColor};
    border-radius: 50%;

    & + * {
      margin-left: ${({ size }) => {
        if (size === AVATAR_SIZES.MEDIUM) return `-${spacing.half}`;
        if (size === AVATAR_SIZES.LARGE) return `-${spacing.half}`;
        if (size === AVATAR_SIZES.SMALL) return `-${spacing.quarter}`;
        if (size === AVATAR_SIZES.XLARGE) return `-${spacing.base}`;
        return `-${spacing.half}`;
      }};
    }
  }
`;

type AvatarStackProps = {
  avatars: AvatarProps[];
  backgroundColor?: string;
  hasTooltip?: boolean;
  numberToDisplay?: number;
  size?: AVATAR_SIZE_TYPES;
};

export const AvatarStack = ({
  avatars,
  backgroundColor = colors.white,
  hasTooltip = false,
  numberToDisplay = 3,
  size = AVATAR_SIZES.SMALL,
}: AvatarStackProps) => {
  return (
    <StackedRow backgroundColor={backgroundColor} size={size}>
      {avatars.slice(0, numberToDisplay).map((avatar, index) => (
        <Tooltip
          key={`${avatar.firstName}${index}`}
          isEnabled={hasTooltip}
          tooltipContent={`${avatar.firstName} ${avatar.lastName}`}
        >
          <Avatar {...avatar} size={size} />
        </Tooltip>
      ))}
      {avatars?.length > numberToDisplay && (
        <CountAvatar count={avatars.length - numberToDisplay} size={size} />
      )}
    </StackedRow>
  );
};
